import React from 'react';
import { Notification } from '@deal/components';

/**
 * This is a handler for errors on the NODE level
 */

var ErrorViewModel = function ErrorViewModel(_ref) {
  var errorViewModel = _ref.errorViewModel;
  return React.createElement(Notification, {
    type: "error"
  }, errorViewModel.errorMessage);
};

export default ErrorViewModel;
//# sourceMappingURL=index.js.map
